module.exports = "/images/ny-blck-9.jpg";